// extracted by mini-css-extract-plugin
export default {"custom-width":"Account_custom-width__IUTT8","linkClass":"Account_linkClass__D8fy0"};